import { DataAnalytics, DataObject } from './common';
const promoTabPageSubFunction = {
    error: 'promotions',
    noCurrentPromotions: 'no_current_promotions',
    noExpiredPromotions: 'no_expired_promotions',
    noPromos: 'no_promos',
    promotions: 'promotions'
};
export const getPromoCenterTabAnalyticsEvent = (event) => ({
    pageFunction: 'promo_tab',
    pageKind: 'activity',
    pageName: event === 'error' ? 'error' : 'view',
    pageSubFunction: promoTabPageSubFunction[event]
});
const promoDetailsPageName = {
    deferredInterestPastDue: 'deferred_interest_pastdue',
    deferredInterestSuccess: 'deferred_interest_success',
    promoExpires: 'promo_expires'
};
export const getPromoCenterDetailsAnalyticsEvent = (event) => ({
    pageFunction: 'promotion_details',
    pageKind: 'activity',
    pageName: promoDetailsPageName[event],
    pageSubFunction: 'promo_progress'
});
export const getPromoCenterTabEventName = (active, expired) => {
    const existsActive = active.length > 0;
    const existsExpired = expired.length > 0;
    if (!existsActive && !existsExpired)
        return 'noPromos';
    if (existsActive && !existsExpired)
        return 'noExpiredPromotions';
    if (!existsActive && existsExpired)
        return 'noCurrentPromotions';
    return 'promotions';
};
var PromoCenterDataType;
(function (PromoCenterDataType) {
    PromoCenterDataType["promos"] = "promos";
    PromoCenterDataType["promoTermDetails"] = "promo-term-details";
    PromoCenterDataType["close"] = "close";
    PromoCenterDataType["xButton"] = "x button";
})(PromoCenterDataType || (PromoCenterDataType = {}));
var PromoCenterDataReason;
(function (PromoCenterDataReason) {
    PromoCenterDataReason["promosTab"] = "promos-tab";
    PromoCenterDataReason["promos"] = "promos";
    PromoCenterDataReason["promosDetails"] = "promos-details";
})(PromoCenterDataReason || (PromoCenterDataReason = {}));
export const getPromoCenterAnalyticsProps = (toggle) => {
    return {
        tab: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': toggle ? DataObject.expand : DataObject.collapse,
            'data-reason': PromoCenterDataReason.promosTab,
            'data-type': PromoCenterDataType.promos
        },
        accordion: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': toggle ? DataObject.expand : DataObject.collapse,
            'data-reason': PromoCenterDataReason.promos,
            'data-type': PromoCenterDataType.promoTermDetails
        },
        promotions: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': toggle ? DataObject.button : DataObject.collapse,
            'data-reason': PromoCenterDataReason.promosDetails,
            'data-type': PromoCenterDataType.close
        },
        xButton: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': DataObject.button,
            'data-reason': PromoCenterDataReason.promosDetails,
            'data-type': PromoCenterDataType.xButton
        }
    };
};
//# sourceMappingURL=promo-center.js.map